<template>
  <div :class="`offShelfWrap ${isNight ? 'offShelfWrap_dark' : ''}`">
    <head-nav
      class="headNav"
      :isNight="isNight"
    />
    <compConnectionless :tip="content" :isNight="isNight" :isInternet="isInternet">
      <button class="btn textBtn" @click="onBtnClick" v-if="!isUpgrade">
        <div class="text">
          {{ btnText }}
        </div>
        <img :src="arrowUrl" class="rightTip" />
      </button>
      <button v-else class="btn upgradeBtn" @click="onBtnClick">
        {{ btnText }}
      </button>
    </compConnectionless>
  </div>
</template>

<script>
import compConnectionless from '@src/components/connectionless'
import rightArrow from '../images/rightArrows.webp'
import HeadNav from '@src/components/head_nav'
// import setStatusBarFontColor from '@src/scripts/interfaces/setStatusBarFontColor'

export default {
  components: {
    compConnectionless,
    HeadNav
  },
  props: ['content', 'btnText', 'isUpgrade', 'isNight','isInternet'],
  computed: {
    arrowUrl() {
      return rightArrow
    }
  },
  mounted() {
    // setStatusBarFontColor(false)
  },
  methods: {
    onBtnClick: function() {
      this.$emit('onBtnClick')
    }
  }
}
</script>

<style lang="stylus" scoped>
.offShelfWrap {
  width: 100%;
  height: 100%;
  background: #fafafa;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .headNav {
    position: fixed
    width: 100%;
    top:0;
    padding-top:0.96rem;
    z-index: 10;
    background:rgba(89,184,126,0);
  }
  .btn {
    border: none;
    font-weight: 500;
    background: transparent;
    display: flex;
    align-items: center;
  }
  .textBtn {
    color: #fd8326;
    font-size: 0.42rem;
    margin-top: 0.24rem;
    height: 0.72rem;
    word-break:keep-all
    font-family: 'OPPOSans 2.14 NoVF';
    .text {
      height: 0.72rem;
      line-height: 0.72rem;
    }
  }
  .upgradeBtn {
    // background: #fd8326;
    margin-top: 0.18rem;
    font-size: 0.42rem;
    color: #fd8326;
    border-radius: 0.42rem;
    width: 1.83rem;
    height: 0.84rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'OPPOSans 2.14 NoVF';
  }
  .rightTip {
    width: 0.72rem;
    height: 0.72rem;
  }
}

.offShelfWrap_dark {
  background-color: #000;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/defaultPage.vue